module.exports = __webpack_public_path__ + "img/greenEnergy.f6f626c9.png";